import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';
import { CreateModuleForm } from 'components';


@translate(['common'])
export default class AddModule extends Component {
  render() {
    const {
      t,
    } = this.props;

    const styles = require('./AddModule.scss');

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title={t("modules.create_module")}/>
        <h1>
          {t("modules.create_module")}
        </h1>

        <CreateModuleForm key="createModuleForm1" />
      </div>
    );
  }
}
